/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetGlobalRemoteSessionIssuerMigratePreflightSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetGlobalRemoteSessionIssuerMigratePreflightRequest = {
  /**
   * The organization- or project-level remote_session_issuer to migrate away from.
   */
  sourceId: string;
  /**
   * The global remote_session_issuer to migrate onto.
   */
  targetId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetGlobalRemoteSessionIssuerMigratePreflightSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGlobalRemoteSessionIssuerMigratePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetGlobalRemoteSessionIssuerMigratePreflightSecurity$Outbound,
    GetGlobalRemoteSessionIssuerMigratePreflightSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getGlobalRemoteSessionIssuerMigratePreflightSecurityToJSON(
  getGlobalRemoteSessionIssuerMigratePreflightSecurity:
    GetGlobalRemoteSessionIssuerMigratePreflightSecurity,
): string {
  return JSON.stringify(
    GetGlobalRemoteSessionIssuerMigratePreflightSecurity$outboundSchema.parse(
      getGlobalRemoteSessionIssuerMigratePreflightSecurity,
    ),
  );
}

/** @internal */
export type GetGlobalRemoteSessionIssuerMigratePreflightRequest$Outbound = {
  source_id: string;
  target_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGlobalRemoteSessionIssuerMigratePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetGlobalRemoteSessionIssuerMigratePreflightRequest$Outbound,
    GetGlobalRemoteSessionIssuerMigratePreflightRequest
  > = z.pipe(
    z.object({
      sourceId: z.string(),
      targetId: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sourceId: "source_id",
        targetId: "target_id",
        gramSession: "Gram-Session",
      });
    }),
  );

export function getGlobalRemoteSessionIssuerMigratePreflightRequestToJSON(
  getGlobalRemoteSessionIssuerMigratePreflightRequest:
    GetGlobalRemoteSessionIssuerMigratePreflightRequest,
): string {
  return JSON.stringify(
    GetGlobalRemoteSessionIssuerMigratePreflightRequest$outboundSchema.parse(
      getGlobalRemoteSessionIssuerMigratePreflightRequest,
    ),
  );
}
